export { default } from "components/Organisms/DatastoresMenu/DatastoreCategory/DatastoreCategory";
